import { render } from "./about.vue?vue&type=template&id=01135e43&scoped=true&bindings={\"topImg\":\"data\",\"leftnavIcon1\":\"data\",\"leftnavIcon2\":\"data\",\"questionIcon1\":\"data\",\"questionIcon2\":\"data\",\"changeContent\":\"data\"}"
import script from "./about.vue?vue&type=script&lang=js"
export * from "./about.vue?vue&type=script&lang=js"

import "./about.vue?vue&type=style&index=0&id=01135e43&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-01135e43"

export default script